import React from 'react';
import { useRouter } from 'next/router';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryMenuSections from 'src/dispensary/hooks/use-dispensary-menu-sections';
import { WhoopsContent, WhoopsReason } from 'components/whoops';

import Menu from 'components/menu';
import useStores from 'shared/hooks/use-stores';

import { GqlMenuSection } from 'types/graphql';
import { defaultFilters } from 'src/components/carousels/carousels.utils';

export function CoreMenuCollectionPage(): JSX.Element | null {
  const { UI } = useStores();
  const { dispensary } = useDispensary();
  const { menuSections } = useDispensaryMenuSections();
  const router = useRouter();
  const menuSection = menuSections.filter((section: GqlMenuSection) => section.id === router.query.menuSectionId)[0];

  const { products, loading, totalCount, totalPages } = useDispensaryProducts({
    filters: {
      ...defaultFilters,
      // Use collectionId (UUID) for proper filtering in MongoDB
      // Falls back to productIds for non-collection sections
      collectionId: menuSection?.collectionId,
      productIds: menuSection?.products,
    },
    perPage: UI.isKiosk ? 20 : 50,
  });

  if (!dispensary) {
    return null;
  }

  if (!loading && !menuSection) {
    return <WhoopsContent reason={WhoopsReason.pageNotFound} />;
  }

  return (
    <>
      <Menu
        products={products}
        totalCount={totalCount}
        totalPages={totalPages}
        loading={loading}
        dispensary={dispensary}
        page='category'
        displaySidebar={false}
        collection={menuSection}
        hideFilters
      />
    </>
  );
}
